<template>
	<div  class="msg_box">
	  <div class="magtop60">
	  <iframe src="https://dojindo.cn/calc/" width="1200px" frameBorder=0 height="2000px" scrolling="auto" marginWidth=0 marginHeight=0 ></iframe>
			<!-- <moer></moer> -->
	  </div>
  </div>
</template>
<script>
export default {
	data(){
		return{
			C1:'',
			C1_select:'-3',
			V1:'',
			V1_select:'-3',
			C2:'',
			C2_select:'-3',
			V2:'',
			V2_select:'-3',
			init_con:'',
			multiple:'',
			cxList:[],
			logxList:[]
		}
	},
	methods:{
		count2(){//连续稀释计算
			let {init_con,multiple} = this;
			if (init_con >= 0 && multiple >= 0){
				var concentration = init_con;
				let cxList=[],logxList = [];
				for(let i=0;i<=8;i++){
					concentration = concentration / multiple;
					cxList.push(concentration);
					logxList.push(Math.log(concentration)/Math.log(10))
				}
				this.cxList = cxList;
				this.logxList = logxList;
            }
		},
		count(){//稀释计算
			let {C1,C1_select,V1,V1_select,C2,C2_select,V2,V2_select} = this;
			//体积
			let start_con = C1 * this.cal10N(C1_select);
			let desired_vol = V1 * this.cal10N(V1_select);
			let desired_con = C2 * this.cal10N(C2_select);
			let deeded_vol = desired_con/start_con * desired_vol;
			let result;
			if (desired_con > start_con)result=-1;
			else result = deeded_vol;
			if(result<0){
				this.V2 = 'impossible';
			}else{
				var map = ['L','mL','μL','nL'];
				var i = 0 ;
				while(result < 1 && i<4){
					result *= 1000;
					i++;
				}
				this.V2 = result;
				this.V2_select = map[i];
			}
		},
		cal10N(n){
            return Math.pow(10,n);
        }
	}
}
</script>
<style lang="scss" scoped>
.cxvalue{
	padding: 0 40px
}
.tech_title{
	font-weight: 600;
}
.dilution{
	.dilution_left{
		.laing_btn{
			margin-top: 30px;
		}
	}
	.dilution_right{
		.diluion_zi{
			span{
				margin-right: 100px;
			}
		}
	}
}
.reds{
	font-size: 16px;
	color: #b03130;
	line-height: 36px;
}
.calcula{
	font-size: 15px;
    font-weight: bold;
    line-height: 30px;
    margin: 0 5px;
    vertical-align: middle;
	color: #B03130;
	&> *{
		margin-right: 5px;
	}
	select{
		height: 30px;
		width: 60px;
		border: 1px solid #D9D9D9;
	}
}
	input[type="text"]{
		height: 30px;
		border: 1px solid #D9D9D9;
		width: 280px;
		margin-top: 10px;
	}
.tech_title{
	margin-bottom: 15px;
}
.tool_title{
		font-size: 18px;
		font-weight: 600;
		color: #333333;
		line-height: 36px;
	}
	.tool_hui{
		font-size: 18px;
		padding: 5px 0;
		color: #666666;
	}
	.tool_lan{
		font-size: 18px;
		font-weight: 600;
		padding: 5px 0;
		color: #005599;
	}
	.mar_top_50{
		font-size: 18px;
		margin-bottom: 10px;
	}
</style>